import trackingEventDictionary from "@core/dictionary/tracking-event";
import { generateTrackingObject } from "@core/global/global-country-functions";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import nodataimage from "./../../../../assets/images/common/no-data.png";
import { toast } from "react-toastify";
import styles from "./styles/company-contact.module.scss";
import { useDispatch, useSelector } from "react-redux";
import ScanContacts from "@components/CompanyProfileContact/ScanContacts";
import commaFormat from "@utils/commaFormat";
import { profileTypeEndPoint } from "@components/templates/Profile/ProfileHeader/profile-enum";
import axios from "axios";
import { useState } from "react";
import { Form } from "react-bootstrap";
import SearchContacts from "@components/CompanyProfileContact/SearchContacts";
import DemoTouchPoint from "@routes/intel/onboarding-screens/onboarding/VideoOpenerStrip";
import { apolloContactsDataHandler } from "@redux/ProfileContacts/profileContactsSlice";
import Loader from "@/components/base/loader/Loader";
const navbarButtonEnum = {
  employeeLevel: "employeeLevel",
  shipmentLevel: "shipmentLevel",
};

const tabEnum = {
  searchContact: "searchContact",
  viewedContact: "viewedContact",
  scanContact: "scanContact",
};

const CompanyContacts = (props) => {
  let { data, dataSource, pathName, currentUserPlan, eventName, userCredit, setValueAddCredit } = props;
  const [currentTab, setCurrentTab] = useState(props?.isSalesForce ? tabEnum.viewedContact : tabEnum.searchContact);
  const [viewedContactList, setViewedContactList] = useState([]);
  const [isLoaderActive, setIsLoaderActive] = useState(false);
  const [isChildLoaderActive, setIsChildLoaderActive] = useState(false);
  const { profileContactData } = useSelector((state) => state);
  const [currentSelecteNavButton, setCurrentSelecteNavButton] = useState(navbarButtonEnum.employeeLevel);
  const dispatch = useDispatch();
  const getViewedContacList = () => {
    const requestObject = {
      company_id: data.companyData.id,
    };
    setIsLoaderActive(true);
    const contactApiUrl = profileTypeEndPoint.getViewedContacList;
    axios
      .post(contactApiUrl, requestObject)
      .then((res) => {
        if (res?.data?.data?.viewedContactsList && Array.isArray(res.data.data.viewedContactsList)) {
          setViewedContactList(JSON.parse(JSON.stringify(res.data.data.viewedContactsList)));
        } else throw new Error();
      })
      .catch(() => {
        toast.error("Something went wrong. Please try again!");
      })
      .finally(() => setIsLoaderActive(false));
  };
  const headerExtra = (
    <div className="tw-flex tw-items-center tw-gap-4">
      {!props?.isSalesForce && (
        <div className="tw-flex tw-items-center">
          <label htmlFor="show-viewed-contacts-only-switch" className="mr-1 tw-text-sm tw-mb-0 tw-cursor-pointer">
            Show viewed contacts only
          </label>
          <span className={currentTab === tabEnum.viewedContact ? "twolevel-checkbox" : "twolevel-checkbox-uncheck"}>
            <Form.Check
              type="switch"
              id="show-viewed-contacts-only-switch"
              checked={currentTab === tabEnum.viewedContact}
              onChange={(e) => {
                if (e.target.checked) {
                  setCurrentTab(tabEnum.viewedContact);
                  dispatch(apolloContactsDataHandler({}));
                  getViewedContacList();
                } else {
                  setCurrentTab(tabEnum.searchContact);
                }
                trademoTrackingEvents(trackingEventDictionary.companyProfilePageSearchContactsTab, generateTrackingObject(dataSource, pathName, currentUserPlan));
              }}
            />
          </span>
        </div>
      )}
      <div className="tw-flex tw-items-center tw-whitespace-nowrap tw-bg-[#ff7d1c1a] tw-px-2">
        <img className="tw-pe-2" src="https://res.cloudinary.com/ddfycftwg/image/upload/v1641874517/images/icons/Iconly_Bold_Info_Circle_bwgt7p.svg" alt="info" height="28px" width="28px" />
        <span className="tw-text-sm">Remaining Value Add Credit(s) :&nbsp;</span>
        <span className="tw-text-sm tw-font-semibold">{data?.creditsLoading ? "..." : commaFormat(data?.valueAddCredit)}</span>
      </div>
    </div>
  );

  return (
    <>
      <div className={`d-flex ${styles.navbar}`}>
        <div className={`d-flex ${styles.navbar_tabs}`}>
          <div onClick={() => setCurrentSelecteNavButton(navbarButtonEnum.employeeLevel)} className={`cursor-pointer ${styles.navbar_button} ${currentSelecteNavButton === navbarButtonEnum.employeeLevel ? styles.navbar_active_button : ""}`}>
            <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="currentColor">
              <path d="M40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm720 0v-120q0-44-24.5-84.5T666-434q51 6 96 20.5t84 35.5q36 20 55 44.5t19 53.5v120H760ZM247-527q-47-47-47-113t47-113q47-47 113-47t113 47q47 47 47 113t-47 113q-47 47-113 47t-113-47Zm466 0q-47 47-113 47-11 0-28-2.5t-28-5.5q27-32 41.5-71t14.5-81q0-42-14.5-81T544-792q14-5 28-6.5t28-1.5q66 0 113 47t47 113q0 66-47 113Z" />
            </svg>
            Employee Level Contacts
          </div>
          {profileContactData?.isContactScanDataPresent ? (
            <div
              onClick={() => {
                trademoTrackingEvents(trackingEventDictionary.companyProfileScanShipmentTab, generateTrackingObject(dataSource, pathName, currentUserPlan));
                setCurrentSelecteNavButton(navbarButtonEnum.shipmentLevel);
              }}
              className={`cursor-pointer ${styles.navbar_button} ${currentSelecteNavButton === navbarButtonEnum.shipmentLevel ? styles.navbar_active_button : ""}`}>
              <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="currentColor">
                <path d="M360-120H200q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h160v80H200v560h160v80Zm80 80v-880h80v880h-80Zm160-80v-80h80v80h-80Zm0-640v-80h80v80h-80Zm160 640v-80h80q0 33-23.5 56.5T760-120Zm0-160v-80h80v80h-80Zm0-160v-80h80v80h-80Zm0-160v-80h80v80h-80Zm0-160v-80q33 0 56.5 23.5T840-760h-80Z" />
              </svg>
              Extracted Contacts <span className={`${styles.no_cost_text}`}>Costs 0 credits</span>
            </div>
          ) : (
            <></>
          )}
        </div>
        <div className="tw-flex tw-ml-auto">
          <DemoTouchPoint module={"fetch_prospects_contacts"} />
        </div>
      </div>
      {currentSelecteNavButton === navbarButtonEnum.shipmentLevel ? (
        <ScanContacts dataSource={dataSource} pathName={pathName} currentUserPlan={currentUserPlan} />
      ) : (
        <div className="container-fluid tabs-first contact-details pl-0">
          <div>
            {currentTab === tabEnum.searchContact ? (
              <SearchContacts data={data} dataSource={dataSource} userCredit={userCredit} setValueAddCredit={setValueAddCredit} pathName={pathName} currentUserPlan={currentUserPlan} eventName={eventName} setCurrentScanTab={() => setCurrentSelecteNavButton(navbarButtonEnum.shipmentLevel)} currentTab={currentTab} headerExtra={headerExtra} onLoadingChange={setIsChildLoaderActive} />
            ) : currentTab === tabEnum.viewedContact ? (
              viewedContactList && viewedContactList.length ? (
                <SearchContacts data={data} dataSource={dataSource} userCredit={userCredit} setValueAddCredit={setValueAddCredit} pathName={pathName} currentUserPlan={currentUserPlan} eventName={eventName} setCurrentScanTab={() => setCurrentSelecteNavButton(navbarButtonEnum.shipmentLevel)} viewedContactList={viewedContactList} currentTab={currentTab} headerExtra={headerExtra} onLoadingChange={setIsChildLoaderActive} />
              ) : (
                <>
                  <div className="tw-flex tw-justify-end tw-w-full tw-pt-3 tw-pb-2">{headerExtra}</div>
                  <div className="d-flex w-100 justify-content-center mt-5">
                    <div className="d-flex flex-column justify-content-center align-items-center">
                      <span>
                        <img className="img-fluid ml-4" src={nodataimage} alt="No Data Found" />
                      </span>
                      <span className="d-block">You have not viewed any contact for {data && data.companyData && data.companyData.name ? <span className="text-capitalize"> {data.companyData.name.split("-").join(" ")}</span> : "this company"}. Once you view the contacts, they would start appearing here.</span>
                    </div>
                  </div>
                </>
              )
            ) : (
              <></>
            )}
          </div>
        </div>
      )}
      {isLoaderActive || isChildLoaderActive ? <Loader /> : <span className="d-none" />}
    </>
  );
};
export default CompanyContacts;
